import { generateRandomText } from "../../utils/helpers";





export const createSubWorkflowTemplates = () => {

    const randomText = generateRandomText()

    return {

        startWFTask: {
            asyncComplete: false,
            displayName: "START SUB WORKFLOW",
            hideTask: false,
            inputParameters: {},
            name: "LABEL_START_SUB_WORKFLOW",
            optional: false,
            taskReferenceName: `LABEL_START_SUB_WORKFLOW_${randomText}_ref`,
            type: "LABEL",
            isSubWF: true,
        },

        endWFTask: {
            asyncComplete: false,
            displayName: "END SUB WORKFLOW",
            hideTask: false,
            inputParameters: {},
            name: "LABEL_END_SUB_WORKFLOW",
            optional: false,
            taskReferenceName: `LABEL_END_SUB_WORKFLOW_${randomText}_ref`,
            type: "LABEL",
        }




    }


}